import React from 'react';
import Input from '../atoms/Input';
import { Search, X } from 'lucide-react';
import { cn } from '../utils/cn';

/**
 * SearchBox Component - Molecule
 * Search input with icon and clear button
 * 
 * @param {Object} props
 * @param {string} props.value - Search value
 * @param {Function} props.onChange - Change handler
 * @param {Function} props.onClear - Clear handler
 * @param {string} props.placeholder - Placeholder text
 */
const SearchBox = React.forwardRef(
  (
    {
      value,
      onChange,
      onClear,
      placeholder = 'Search...',
      className = '',
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn('relative', className)}>
        <Input
          ref={ref}
          type="search"
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          leftIcon={<Search size={18} />}
          rightIcon={
            value && (
              <button
                type="button"
                onClick={onClear}
                className="hover:text-primary-600 dark:hover:text-primary-400 transition-colors"
                aria-label="Clear search"
              >
                <X size={18} />
              </button>
            )
          }
          {...props}
        />
      </div>
    );
  }
);

SearchBox.displayName = 'SearchBox';

export default SearchBox;
